@if (showCookieBanner) {
<div class="cookie-banner" #cookieBanner>
  <p>
    We use cookies via a third-party tool to analyze our traffic, monitor usage, and understand user interactions.  By clicking "Accept" you consent to the use of cookies.
  </p>
  <button (click)="acceptCookies()">Accept</button>
  <button (click)="rejectCookies()">Reject</button>
</div>
}
